/**
 * @architecture-header 1
 * @layer shared
 * @domain visual-language
 * @responsibility Render the canonical Vispo animated loading state across workspace surfaces.
 * @state-owner none
 * @allowed-imports BrandMarks
 * @forbidden business rules; network; substitute spinners
 * @public-api workspace routes, popovers, and modules
 * @side-effects authored logo animation only
 * @tests workspace Playwright flows
 */

import { VispoAnimatedMark } from './BrandMarks';

export function VispoLoading({ className = '', label }: { className?: string; label: string }) {
  return (
    <div aria-label={label} className={`vispo-loading ${className}`} role="status">
      <VispoAnimatedMark className="vispo-loading__mark" />
      <span>{label}</span>
    </div>
  );
}

export function VispoInlineLoading({ label }: { label: string }) {
  return (
    <span aria-label={label} className="vispo-inline-loading" role="status">
      <VispoAnimatedMark className="vispo-inline-loading__mark" />
      <span>{label}</span>
    </span>
  );
}
